module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/ldp-9dced5d4a103a6634e465898cae31fe8.svg";